import { API_CONFIG } from '../config';
import {
  isCompanySecretaryRole,
  isGroupScopeRole,
  normalizeCsAdminRole,
} from '../constants/csAdminRoles';

export const PORTAL_MODES = {
  CS: 'cs',
  CSADMIN: 'csadmin',
};

export function userUsesCompanySecretaryPortal(role) {
  return isCompanySecretaryRole(role);
}

export function userUsesGroupCsPortal(role) {
  return isGroupScopeRole(role);
}

/** Whether the user's role belongs on the current SPA build (company vs group portal). */
export function userBelongsOnCurrentPortal(role, portalMode = API_CONFIG.PORTAL_MODE) {
  const normalized = normalizeCsAdminRole(role);
  if (portalMode === PORTAL_MODES.CS) {
    return userUsesCompanySecretaryPortal(normalized);
  }
  if (portalMode === PORTAL_MODES.CSADMIN) {
    return userUsesGroupCsPortal(normalized);
  }
  return false;
}

export function getPortalPublicPath(portalMode) {
  return portalMode === PORTAL_MODES.CS ? '/companysecretary' : '/groupcompanysecretary';
}

export function getPortalBaseUrlForRole(role) {
  if (userUsesCompanySecretaryPortal(role)) {
    return String(API_CONFIG.CS_PORTAL_URL || '').replace(/\/$/, '');
  }
  if (userUsesGroupCsPortal(role)) {
    return String(API_CONFIG.CSADMIN_URL || '').replace(/\/$/, '');
  }
  return null;
}

/**
 * Full URL on the correct portal host/path for a cross-portal redirect.
 * @param {object} user - session user with role
 * @param {string} pathname - router path relative to basename (e.g. /dashboard)
 * @param {string} [search] - query string including leading ?
 */
export function buildPortalRedirectUrl(user, pathname = '/dashboard', search = '') {
  const base = getPortalBaseUrlForRole(user?.role);
  if (!base) return null;
  const relative = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${base}${relative}${search || ''}`;
}

export function isAdminPortalBuild(portalMode = API_CONFIG.PORTAL_MODE) {
  return portalMode === PORTAL_MODES.CSADMIN;
}

export const WRONG_PORTAL_LOGIN_MESSAGE =
  'This account cannot sign in here. Company Secretaries must use the Company Secretary portal; '
  + 'IT Admin and Group Company Secretary accounts must use the Group Company Secretary portal.';
